<section class="home-hero">
  @if (hero) {

    @if (hero.backgroundType === 'Video' && mediaUrl) {
      <video
        #heroVideo
        class="hero-background"
        autoplay
        [muted]="true"
        loop
        playsinline
        preload="auto"
        [src]="mediaUrl"
        [attr.poster]="fallbackMediaUrl"
        (canplay)="startHeroVideo(heroVideo)"
        aria-hidden="true"
      ></video>
    
    }
    @else if (isImage && mediaUrl) {
      <img
        class="hero-background"
        [src]="mediaUrl"
        alt=""
        aria-hidden="true"
      />
    }

    @if (hero.eyebrowText) {
      <div class="hero-eyebrow">
        <img class="m" [src]="branding.logoUrl()" alt="" />
        <span class="eyebrow-text">{{ hero.eyebrowText }}</span>
      </div>
    }

    <div class="hero-main">
      <h1>
        {{ hero.title }}

        @if (hero.accentText) {
          <span class="hero-accent">{{ hero.accentText }}</span>
        }
      </h1>

      @if (hero.subtitle) {
        <p class="hero-sub">{{ hero.subtitle }}</p>
      }
    </div>

  }
</section>
